import { IconButton } from "@mui/material";
import { copyToClipBoard } from "../../../../../utils";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export default function CopyToClipBoard({text}){
  return(
    <>
    <IconButton
      variant="outlined"
      color="primary"
      sx={{
        borderRadius: "0 0.5em 0.5em 0",
        height: "1.2em",
      }}
      onClick={() => copyToClipBoard(text)}>
      <ContentCopyIcon />
    </IconButton>
    </>
  )
}